module.exports = __webpack_public_path__ + "media/svg/gq-ad0ccfc2.svg";